<div class="dropdown menu">
  <a class="cg-icon-md cg-margin-right-md" data-test="header-user-name">{{
    'am.helpLink.header' | translate
  }}</a>
  <cigna-icon-triangle
    size="medium"
    color="blue"
    direction="south"
  ></cigna-icon-triangle>
  <div class="dropdown-content">
    <button
      cignaButton="link no-underline"
      data-test="txt-help-questions"
      (click)="openExplainAccessDialog()"
    >
      {{ 'am.helpLink.help.entitlements' | translate }}
    </button>
    <button
      cignaButton="link no-underline"
      data-test="txt-help-faq"
      (click)="openHelpFaqDialog()"
    >
      {{ 'am.helpLink.help.faq' | translate }}
    </button>
  </div>
</div>
